module.exports = __webpack_public_path__ + "img/complete.a2ddcb76.png";